import React from "react"
import Menu, { MenuDivider, MenuItem } from "components/dialogs/Menu"
import { Checkbox, Flex, Text } from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import useAvailableColumns from "../TableView/DataTable/useAvailableColumns"
import { useColumnVisibilityContext } from "../ColumnVisibilityProvider"

const ColumnVisibilityMenu = () => {
  const { columnVisibility, updateColumnVisibility } = useColumnVisibilityContext()

  const allColumns = useAvailableColumns()
  const personColumns = Object.values(allColumns).filter((col) => col.group === "person")
  const eventColumns = Object.values(allColumns).filter((col) => col.group === "event")

  const menuItems = [
    <Text key="person-header" px={4} py={2} fontWeight="semibold">
      Show Person Attributes
    </Text>,
    ...personColumns.filter((col) => col.id !== "name").map((col) => (
      <MenuItem
        key={col.id}
        px={4}
        py={2}
        onClick={() => {
          updateColumnVisibility(col.id, !columnVisibility?.[col.id]?.isVisible)
        }}
        closeOnSelect={false}
      >
        <Checkbox
          isChecked={columnVisibility?.[col.id]?.isVisible}
          spacing={4}
          pointerEvents="none"
          onChange={() => {}}
        >
          <Flex align="center">
            <Icon icon={col.icon} mr={3} color="gray.600" />
            {col.label}
          </Flex>
        </Checkbox>
      </MenuItem>
    )),
    <MenuDivider key="divider" />,
    <Text key="event-header" px={4} py={2} fontWeight="semibold">
      Show Event Attributes
    </Text>,
    ...eventColumns.map((col) => (
      <MenuItem
        key={col.id}
        px={4}
        py={2}
        onClick={() => {
          updateColumnVisibility(col.id, !columnVisibility?.[col.id]?.isVisible)
        }}
        closeOnSelect={false}
      >
        <Checkbox
          isChecked={columnVisibility?.[col.id]?.isVisible}
          spacing={4}
          pointerEvents="none"
          onChange={() => {}}
        >
          <Flex align="center">
            <Icon icon={col.icon} mr={3} color="gray.600" />
            {col.label}
          </Flex>
        </Checkbox>
      </MenuItem>
    )),
  ]

  return (
    <Menu
      buttonIcon="settings-rotated"
      buttonVariant="outline"
      menuItems={menuItems}
      placement="bottom-end"
      closeOnSelect={false}
      maxH="80vh"
    />
  )
}

export default ColumnVisibilityMenu
